import { render, staticRenderFns } from "./TagArticleList.vue?vue&type=template&id=63497c90&scoped=true&"
import script from "./TagArticleList.vue?vue&type=script&lang=js&"
export * from "./TagArticleList.vue?vue&type=script&lang=js&"
import style0 from "./TagArticleList.vue?vue&type=style&index=0&id=63497c90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63497c90",
  null
  
)

export default component.exports